import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

export const SelectDeformadas = (props) => {

  const {
    setDeformadaSeleccionado,
    deformadaSeleccionado
  } = props;

  const estilosSelect = { fontSize: "1em", color: "#646464" };
  const ITEM_HEIGHT = 45;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      },
    },
  };


  return (
    <div>
      <FormControl sx={{ m: 1, minWidth: "100%" }} size="small">
        <InputLabel id="labelTipoContenido">Deformadas</InputLabel>
        <Select
          sx={{ backgroundColor: "#FFFFFF" }}
          style={{ ...estilosSelect, marginBottom: "20px" }}
          MenuProps={MenuProps}
          labelId="labelDeformadas"
          value={deformadaSeleccionado}
          id="selectDeformada"
          label="Deformadas"
          onChange={(e) => {
            // setTipoRetiroSeleccionado(e.target.value);
            setDeformadaSeleccionado(e.target.value);
          }}
        >
          <MenuItem style={estilosSelect} value="2" selected>
            Todas
          </MenuItem>
          <MenuItem style={estilosSelect} value="1">
            Si        
            </MenuItem>
          <MenuItem style={estilosSelect} value="0">
            No
          </MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};
